// extracted by mini-css-extract-plugin
export default {"ModalErrorLogout":"InfoModalCompanent_ModalErrorLogout__g3Z9x","loginButton":"InfoModalCompanent_loginButton__kMuLU","okButton":"InfoModalCompanent_okButton__Ye5Vg"};